import React from 'react';
import { IconBase, IconProps } from '../IconBase';

export const UploadIcon = ({ size, color, title, onClick, decorative, ...restItems }: IconProps) => (
	<IconBase
		viewBox="0 0 20 20"
		size={size}
		color={color}
		title={title}
		onClick={onClick}
		decorative={decorative}
		{...restItems}
	>
		<path
			d="M10.6562 12.5938C10.6562 12.9766 10.3555 13.25 10 13.25C9.61719 13.25 9.34375 12.9766 9.34375 12.5938V4.99219L6.74609 7.58984C6.47266 7.86328 6.0625 7.86328 5.81641 7.58984C5.54297 7.34375 5.54297 6.93359 5.81641 6.66016L9.53516 2.94141C9.78125 2.69531 10.1914 2.69531 10.4375 2.94141L14.1836 6.66016C14.4297 6.93359 14.4297 7.34375 14.1836 7.58984C13.9102 7.86328 13.5 7.86328 13.2539 7.58984L10.6562 4.99219V12.5938ZM11.5312 12.375V11.0625H15.25C16.207 11.0625 17 11.8555 17 12.8125V15C17 15.9844 16.207 16.75 15.25 16.75H4.75C3.76562 16.75 3 15.9844 3 15V12.8125C3 11.8555 3.76562 11.0625 4.75 11.0625H8.46875V12.375H4.75C4.50391 12.375 4.3125 12.5938 4.3125 12.8125V15C4.3125 15.2461 4.50391 15.4375 4.75 15.4375H15.25C15.4688 15.4375 15.6875 15.2461 15.6875 15V12.8125C15.6875 12.5938 15.4688 12.375 15.25 12.375H11.5312ZM13.5 13.9062C13.5 13.5508 13.7734 13.25 14.1562 13.25C14.5117 13.25 14.8125 13.5508 14.8125 13.9062C14.8125 14.2891 14.5117 14.5625 14.1562 14.5625C13.7734 14.5625 13.5 14.2891 13.5 13.9062Z"
			fill="#6AB0BA"
		/>
	</IconBase>
);
